module.exports = __webpack_public_path__ + "static/media/Fonty_Graphik-Regular.93cb8342.ttf";